import { styled, Theme } from '@mui/material';

export const SpinnerContainer = styled('div')`
  position: relative;
  left: 50%;
  top: 50%;
  width: 0.5rem;
  margin-left: -20px;
  margin-top: -20px;
`;

export const SpinnerOverlayContainer = styled(SpinnerContainer)`
  position: fixed;
`;

export const ComponentOverlayContainer = styled('div')`
  ${({ theme }: { theme: Theme }) => `
    background-color: ${theme.palette.common.black.concat('4D')};
    width: 100%;
    height: 100%;
    z-index: 100;
    position: absolute;
  `}
`;

export const BackgroundContainer = styled('div')`
  ${({ theme }: { theme: Theme }) => `
    position: absolute;
    background-color: ${theme.palette.common.black.concat('4D')};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 110;
  `}
`;
